import { Button } from '@service-victoria/component-library/components/Button';
import Text from '@service-victoria/component-library/components/Text';
import { constants } from 'app/utils';
import { useHistory } from 'react-router-dom';
import * as Styled from './styled';

const NotLinkedToProviderError: React.FC = () => {
  const history = useHistory();

  const handleBackButton = () => {
    history.push(constants.Routes.Home);
  };

  return (
    <Styled.Wrapper>
      <Styled.Content>
        <Text.Heading.H1 fontWeight='bold'>Are you an Activity Provider?</Text.Heading.H1>
        <Text.Body>
          If you&apos;re trying to use or apply for a voucher, you&apos;ve come to the wrong place.
        </Text.Body>
        <Text.Body>This portal is for Activity Providers.</Text.Body>
        <Text.Body>
          <Text.Link href={constants.OUTDOOR_GAK_PATH}>Take me back</Text.Link>
        </Text.Body>
        <Styled.Spacer24 />
        <Text.Heading.H1 fontWeight='bold'>If you&apos;re an Activity Provider</Text.Heading.H1>
        <Styled.Spacer24 />
        <Text.Heading.H2 fontWeight={600}>Your account may not be approved yet</Text.Heading.H2>
        <Text.Body>
          Once the Department of Jobs, Skills, Industry and Regions (DJSIR) approves your account,
          you can check and redeem vouchers.
        </Text.Body>
        <Text.Heading.H2 fontWeight={600}>Transferring an account to you</Text.Heading.H2>
        <Text.Body>
          If someone in your organisation already has an account, they will need to transfer it to
          you.
          <br />
          To transfer the account, they need to email DJSIR at{' '}
          <Text.Link
            target='_blank'
            href='mailto:getactivekids@sport.vic.gov.au?subject=Transfer Get Active Kids account'
            data-testid='notLinkedToProviderError.getActiveKidsEmail'>
            getactivekids@sport.vic.gov.au
          </Text.Link>
          .
          <br />
          Please include &apos;Transfer Get Active Kids account&apos; in the subject line.
        </Text.Body>
        <Styled.Spacer60 />
        <Styled.ButtonWrapper>
          <Button buttonType='secondary' onClick={handleBackButton}>
            Back
          </Button>
        </Styled.ButtonWrapper>
      </Styled.Content>
    </Styled.Wrapper>
  );
};

export default NotLinkedToProviderError;
